'use es6';

import invariant from 'react-utils/invariant';
export const assertPropDefined = (prop, propName) => {
  // eslint-disable-next-line no-undef
  if (process.env.NODE_ENV !== 'production') {
    invariant(typeof prop !== 'undefined', `Property '${propName}' is undefined.`);
  }
};
export const assertPropsDefined = props => {
  Object.keys(props).forEach(propName => {
    assertPropDefined(props[propName], propName);
  });
};